import { RegisterWidget, Widget } from "../lib/widget";
import template from './responsive.html'

/**
 * Base Responsive class
 */
@RegisterWidget({tag: 'responsive-widget', displayName: 'Responsive', template: template})
export class ResponsiveWidget extends Widget {
    protected connectedCallback(): void {}
}